// extracted by mini-css-extract-plugin
export default {"button":"fgHLUq","cornerRadiusEnabled":"djvxw2","container":"GcE_Hs","mobile":"uKkRtb","hidden":"gZrHBm","spinnerWrapper":"a5LN1r","loader":"ROSx2b"};